import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY_DARKER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface MappingInProgressIndicatorProps {
  text: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function MappingInProgressIndicator(props: MappingInProgressIndicatorProps): JSX.Element {
  return (
    <div className={css(styles.mappingInProgressIndicator)} {...getTestProps(props.dataTestAttrs)}>
      <BenchlingIcon icon="refresh" className="glyphicon-spin" />
      <div className={css(styles.mappingInProgressLabel)}>{props.text}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  mappingInProgressIndicator: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  mappingInProgressLabel: {
    marginLeft: 8,
    color: GRAY_DARKER,
  },
});
